const images = {
  start: 'images/welcome-screen.jpg',
  stepA1: 'images/Noise-reduction-1.jpg',
  stepA2: 'images/Noise-reduction-2.jpg',
  stepA3: 'images/Noise-reduction-3.jpg',
  stepA4: 'images/Noise-reduction-4.jpg',
  stepB1: 'images/Early-detection-1.jpg',
  stepB2: 'images/Early-detection-2.jpg',
  stepB3: 'images/Early-detection-3.jpg',
  stepB4: 'images/Early-detection-4.jpg',
  stepB5: 'images/Early-detection-5.jpg',
  stepB6: 'images/Early-detection-6.jpg',
  stepB7: 'images/Early-detection-7.jpg',
  stepC1: 'images/01_create-runbook.jpg',
  stepC2: 'images/02_create-runbook.jpg',
  stepC3: 'images/03_create-runbook.jpg',
  stepC4: 'images/04_create-runbook.jpg',
  stepC5: 'images/05_run-runbook.jpg',
  stepC6: 'images/06_run-runbook.jpg',
  stepC7: 'images/07_run-runbook.jpg',
  stepC8: 'images/08_run-runbook.jpg',
  stepC9: 'images/09_run-runbook.jpg',
  stepC10: 'images/10_run-runbook.jpg',
  stepD1: 'images/01_show-results.jpg',
  stepD2: 'images/02_show-results.jpg',
};

const videos = {
  startVideo:
    'https://cdnapisec.kaltura.com/p/1511271/sp/151127100/embedIframeJs/uiconf_id/44723621/partner_id/1511271?iframeembed=true&playerId=kaltura_player&entry_id=1_x5psw4mn&flashvars[akamaiHD.loadingPolicy]=preInitialize&flashvars[akamaiHD.asyncInit]=true&flashvars[twoPhaseManifest]=true&flashvars[streamerType]=hdnetworkmanifest&flashvars[localizationCode]=en&flashvars[leadWithHTML5]=true&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[sideBarContainer.plugin]=false&flashvars[controlBarContainer.plugin]=false&flashvars[topBarContainer.plugin]=false&flashvars[unMuteOverlayButton.plugin]=false&flashvars[autoPlay]=true&flashvars[loop]=true&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true&flashvars[Kaltura.addCrossoriginToIframe]=true&&wid=1_iyekr1et',
};

export default {
  ...images,
  ...videos,
};
